/** Номер счётчика Яндекс Метрики. */
export const METRIKA_COUNTER_ID = 43808394;

const TEST_VISIT_SEARCH_PARAM = 'test';
const TEST_VISIT_STORAGE_KEY = 'ym-test-visit';

export function callYm(method: string, ...args: unknown[]): void {
  if (typeof window.ym !== 'function') {
    return;
  }
  window.ym(METRIKA_COUNTER_ID, method, ...args);
}

/**
 * Контейнер электронной коммерции `dataYandexLayer`, заданный в настройках счётчика.
 * Метрика забирает уже накопленные элементы массива, поэтому порядок загрузки
 * кода счётчика и этого бандла значения не имеет.
 */
export function getEcommerceContainer(): Record<string, unknown>[] {
  const container = window.dataYandexLayer ?? [];
  window.dataYandexLayer = container;

  return container;
}

function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  }
  catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  }
  catch {
    // приватный режим — метку поставить нельзя, визит останется обычным
  }
}

function removeStorage(key: string): void {
  try {
    window.localStorage.removeItem(key);
  }
  catch {
    // см. writeStorage
  }
}

/** Визит помечен как тестовый — такие визиты отделяются в отчётах параметром test=1. */
export function isTestVisit(): boolean {
  return readStorage(TEST_VISIT_STORAGE_KEY) === '1';
}

/**
 * `?test=1` помечает браузер как тестовый, `?test=0` снимает метку.
 * Пока метка стоит, каждый визит получает параметр визита и посетителя `test=1`,
 * что позволяет исключить тестовые заказы из отчётов сегментом.
 */
export function initTestVisit(): void {
  const flag = new URLSearchParams(window.location.search).get(TEST_VISIT_SEARCH_PARAM);
  if (flag === '1') {
    writeStorage(TEST_VISIT_STORAGE_KEY, '1');
  }
  else if (flag === '0') {
    removeStorage(TEST_VISIT_STORAGE_KEY);
  }

  if (!isTestVisit()) {
    return;
  }

  callYm('params', { test: 1 });
  callYm('userParams', { test: 1 });
}
